import { buildUrl, defaultFetchHeaders, fetchJson } from "../../utils";
import { PortalLocation } from "./types";
import { Location } from "../types";
import { normalizeLocationResponse } from "../api/location/normalize";
import { Machine } from "../types";
import { normalizeMachineResponse } from "../api/machine/normalize";
import { toLocalISODate } from "../utils";

const backend = process.env.REACT_APP_BACKEND_URL || "";

export type ContactUpcomingLocationTasks = {
  locationId: string;
  scheduledFor: string;
  taskCount: number;
};

export async function fetchPortalLocations(): Promise<PortalLocation[]> {
  const locations = await fetchJson<Location[]>(
    buildUrl(`${backend}/portal/locations`, {}),
    {
      method: "GET",
      credentials: "include",
      headers : await defaultFetchHeaders(),
    },
    "Failed to fetch locations"
  );

  return locations.map(
    (loc: any) => normalizeLocationResponse(loc) as PortalLocation
  );
}

export async function fetchPortalLocationMachines(
  locationId: string
): Promise<Machine[]> {
  if (!locationId) return [];
  const machines = await fetchJson<Machine[]>(
    buildUrl(`${backend}/portal/location/machines`, { id: locationId }),
    {
      method: "GET",
      credentials: "include",
      headers : await defaultFetchHeaders(),
    },
    "Failed to fetch machines"
  );
  return machines.map(normalizeMachineResponse);
}

export async function fetchContactUpcomingTasksByLocation(options?: {
  locationIds?: string[];
  onOrAfter?: string;
}): Promise<ContactUpcomingLocationTasks[]> {
  const locationIds = Array.from(
    new Set((options?.locationIds || []).filter(Boolean)),
  );
  const rows = await fetchJson<any[]>(
    buildUrl(`${backend}/task/machine/contact/upcoming-by-location`, {
      location_ids: locationIds.length ? locationIds.join(",") : undefined,
      on_or_after: options?.onOrAfter || toLocalISODate(new Date()),
    }),
    {
      method: "GET",
      credentials: "include",
      headers: await defaultFetchHeaders(),
    },
    "Failed to fetch upcoming tasks",
  );
  return rows.map((row) => ({
    locationId: String(row.locationId ?? row.location_id ?? ""),
    scheduledFor: String(row.scheduledFor ?? row.scheduled_for ?? ""),
    taskCount: Number(row.taskCount ?? row.task_count ?? 0),
  }));
}
